<mbs-table
  [headers]="headers"
  [loading]="loading()"
  [dataSourceData]="items()"
  (changeSelected)="changeSelected($event)"
  (selectAllOnAllPages)="selectAll($event)"
  [multipleSelect]="multipleSelect()"
  [noDataMessage]="computersNotFound()"
  [showSelectAllCheckbox]="true"
  [showCheckboxes]="multipleSelect()"
  [showSelectAllHint]="multipleSelect()"
  [totalItems]="totalVisibleItems()"
  [totalSelectedItems]="totalSelectedItems()"
  [selectedCountText]="selectedCountText()"
  [selectable]="true"
  [virtualScrolling]="true"
  [virtualItemSize]="40"
  [minBufferPx]="200"
  [maxBufferPx]="2000"
  [keepState]="true"
  [myTrackBy]="trackBy"
  [maxHeight]="maxHeight()"
  [selectRowClass]="'-selected'">
  <ng-template
    mbsTableCell
    let-item>
    @if (showComputerDetails()) {
      @let version = getAgentVersion(item);
      <div class="d-flex w-100 align-items-center">
        <div class="mbs-table-grid_ico mr-2">
          <span [ngClass]="[item | computerOsIcon, item?.online ? 'text-primary' : 'text-muted']"></span>
        </div>

        <span class="fw-bold">{{ item[bindLabel] }}</span>

        @if (item?.online && version) {
          <span class="text-muted ml-2">{{ 'shared:computers.agentVersion' | i18next: { version } }}</span>
        }
      </div>
    } @else {
      {{ item[bindLabel] }}
    }
  </ng-template>
</mbs-table>
